import { useParams, useSearchParams } from 'react-router-dom';
import { SchoolWizard } from './SchoolWizard';

/**
 * Passage en V2 d'une école existante (V1) : reprend le workflow de création
 * avec les champs préremplis depuis la V1, pour qualifier les informations
 * manquantes avant de lancer le déploiement du tenant V2.
 */
export function SchoolUpgradeV2Page() {
  const { code } = useParams<{ code: string }>();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo') || undefined;

  if (!code) return null;

  return <SchoolWizard mode="upgradeV2" schoolCode={code} returnTo={returnTo} />;
}
